import api from "@utils/api";

const ENDPOINT = "/system-settings";

export const SystemSettingsService = {
  list: async () => {
    const response = await api.get(ENDPOINT);
    return response.data;
  },
  getPublicValue: async (key) => {
    const response = await api.get(`${ENDPOINT}/public/${key}`);
    return response.data.data.value;
  },
  store: async (data) => {
    const response = await api.post(ENDPOINT, data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`${ENDPOINT}/${id}`, data);
    return response.data;
  },
  destroy: async (id) => {
    const response = await api.delete(`${ENDPOINT}/${id}`);
    return response.data;
  },
};
